import type { MaybeRefOrGetter } from 'vue';
import type { BlockBase, BlockDefinition, BlockSerialized, BlockSerializedChild, BlockSerializedSlotOutlet } from '#layers/block-engine/types/block';
import type { BlockEditorContext } from '#layers/block-engine/types/block-editor';
import { computed, toValue } from 'vue';
import { callOrReturn } from '#layers/base/public';
import { useBlockEditorContext } from '#layers/block-engine/composables/use-block-editor-context';
import { getBlockConfig, useBlockConfigApi } from '#layers/block-engine/utils/block/api/config';
import { isBlockDefinition, isBlockSerializedChild } from '#layers/block-engine/utils/block/editor';

export function isBlockLocked(
	child: BlockSerializedChild | BlockSerializedSlotOutlet,
	block: BlockBase | BlockDefinition | BlockSerialized | undefined,
	editorContext: BlockEditorContext,
): boolean {
	if (!isBlockSerializedChild(child)) {
		return false;
	}

	if (!isBlockDefinition(block)) {
		return false;
	}

	const blockConfig = getBlockConfig(block);

	const api = useBlockConfigApi(child, editorContext);

	return callOrReturn(blockConfig?.locked ?? false, {
		...api,
		props: child.props,
	});
}

export function useBlockIsLocked(child: MaybeRefOrGetter<BlockSerializedChild | BlockSerializedSlotOutlet>, block: MaybeRefOrGetter<BlockBase | BlockDefinition | BlockSerialized | undefined>) {
	const editorContext = useBlockEditorContext();

	return computed(() => {
		const actualChild = toValue(child);
		const actualBlock = toValue(block);

		return isBlockLocked(actualChild, actualBlock, editorContext);
	});
}
